import React from 'react'
import { getSecret } from '@/features/secrets'
import { useField } from 'formik'

export const useSecretValue = (name: string, projectId: number, secretId: number | undefined) => {
  const [, { value }, { setValue }] = useField(name)
  const [isVisible, setIsVisible] = React.useState(false)

  // Load secret value asynchronously only if the value in input is empty
  const onShow = React.useCallback(async () => {
    setIsVisible(true)
    const isEmpty = typeof value !== undefined && value !== ''
    if (isEmpty || !secretId) return

    const secret = await getSecret(projectId, secretId)
    setValue(secret.value)
  }, [value, setValue, setIsVisible, projectId, secretId])

  const onHide = React.useCallback(async () => {
    setIsVisible(false)
  }, [setIsVisible])

  return {
    isVisible,
    onShow,
    onHide,
  }
}
